import Bouncer from 'approot/shared/bouncer/bouncer';

import * as Styled from './image-sphere-viewer-loading.style';
import { PStyled } from 'approot/shared/styles/typography.style';

const ImageSphereViewerLoading = () => {
  return (
    <Styled.ImageSphereLoadingMessageOuter>
      <Styled.ImageSphereLoadingMessage>
        <Bouncer />
        <PStyled textAlignCenter marginTop={24}>
          Please wait while your 360° image loads. This may take a moment.
        </PStyled>
      </Styled.ImageSphereLoadingMessage>
    </Styled.ImageSphereLoadingMessageOuter>
  );
};

export default ImageSphereViewerLoading;
